import React, {useEffect, useState} from 'react';
import styles from './style.module.scss';

export function ProductImage({src}) {
  const imageRef = React.createRef();
  const [rect, setRect] = useState({});

  useEffect(() => {
    console.log('test');
    if (!imageRef.current) return;
    const rect = imageRef.current.getBoundingClientRect();
    setRect(rect);
    // eslint-disable-next-line
  }, [imageRef.current]);

  const {width} = rect;

  return (
    <div
      className={styles.productThumbnail}
      style={{width: `${width}px`, height: `${width}px`}}
    >
      <a
        href={src}
        ref={imageRef}
        target="_blank"
        rel="noreferrer noopener"
      >
        <img
          src={src}
          alt="상품 이미지"
        />
      </a>
    </div>
  );
}
